import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  box: {
    width: '100%',
  },
  tabPaper: {
    backgroundColor: '#ffffff',
    padding: theme.spacing(3, 0),
    boxShadow: theme.shadows[0],
    '& > div:first-child > div': {
      padding: theme.spacing(0, 2),
    },
  },
  MuiBox: {
    padding: 0,
  },
  row: {
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  title: {
    margin: theme.spacing(0, 3.5, 0, 0),
    fontSize: 14,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  desc: {
    width: 'calc(100% - 145px)',
    borderBottom: '1px solid #E0E0E0',
    padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  gridPaper: {
    height: '100%',
  },
  tabsPanel: {
    width: '100%',
  },
  textBox: {
    marginTop: theme.spacing(3),
    fontSize: 12,
    maxWidth: 580,
    color: 'rgb(0 0 0 / 54%)',
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(3),
  },
  btn: {
    padding: theme.spacing(1, 3.5),
    marginRight: theme.spacing(1),
    fontSize: 14,
    textTransform: 'none',
  },
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 14,
  },
  tabBox: {
    margin: theme.spacing(3.5, 0, 0),

    '& > div > div': {
      padding: 0,
      height: 'calc(100vh - 410px)',
      overflow: 'auto',
    },
  },
  tabs: {
    width: 'fit-content',
    border: '1px solid white',
    borderRadius: '4px 0px 0px 4px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },
    '& .MuiTab-root.Mui-selected': {
      color: 'white',
      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      padding: '16px 24px',
    },
  },
  tabsPaper: {
    width: '100%',
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
    '& [class*="MuiBox-root"]': {
      padding: theme.spacing(2, 0, 0, 0),
    },
  },
}));
